import React, { useState } from "react";
import usePut from "../../../hooks/usePut";
import { at } from "lodash";
import toast from "react-hot-toast";
import { Button } from "../../ui";

const RedeemLeaveDay = ({ day, leaveTypesOptions, companyEmployeeId, id }) => {
  const [isRedeemLeave, setIsRedeemLeave] = useState(day.redeem_leave);
  const [leaveTypeId, setLeaveTypeId] = useState(day.redeem_leave_head_id);
  const [leaveTypeName, setLeaveTypeName] = useState(
    day.redeem_leave_head_name
  );

  const { handleAuth } = usePut({
    url: "payout_redeem_leave",
    onSuccess: () => {
      toast.success(
        isRedeemLeave
          ? "Leave redeemed successfully"
          : "Leave redemption cancelled"
      );
    },
    onError: () => {
      toast.error("Error redeeming leave");
    },
  });

  const handleLeaveTypeChange = (e) => {
    setLeaveTypeId(e.target.value);
    const typeName = leaveTypesOptions.find(
      (option) => option.value === e.target.value
    )?.label;

    setLeaveTypeName(typeName);
  };

  const redeemLeave = () => {
    handleAuth.mutate({
      company_employee_id: companyEmployeeId,
      id: day.id,
      attendance_date: day.attendance_date,
      attendance_month: day.attendance_month,
      attendance_year: day.attendance_year,
      redeem_leave: isRedeemLeave,
      redeem_leave_head_id: leaveTypeId,
      redeem_leave_head_name: leaveTypeName,
      redeem_leave_count: day.present_definition === "half_day" ? 0.5 : 1,
    });
  };

  return (
    <>
      <div className="flex items-center mt-4">
        <input
          type="checkbox"
          name=""
          id={"redeem_leave_" + day.attendance_date}
          onChange={() => setIsRedeemLeave(!isRedeemLeave)}
          checked={isRedeemLeave}
        />
        <label
          htmlFor={"redeem_leave_" + day.attendance_date}
          className="text-xs ml-2"
        >
          Redeem leave
        </label>
      </div>

      {isRedeemLeave && (
        <>
          <select
            name=""
            id=""
            className="text-xs px-1 py-0.5  border rounded-sm mt-2"
            onChange={(e) => handleLeaveTypeChange(e)}
            value={leaveTypeId}
          >
            <option value="" disabled selected>
              Select Leave Type
            </option>
            {leaveTypesOptions?.map((option, idx) => {
              return (
                <option key={idx} value={option.value}>
                  {option.label}
                </option>
              );
            })}
          </select>
        </>
      )}
      <Button
        className="text-xs bg-gray-200 ml-auto mt-2"
        onClick={redeemLeave}
        size={"sm"}
        variant={"outline"}
        type="button"
      >
        Save redemption
      </Button>
    </>
  );
};

export default RedeemLeaveDay;
